
  import axios, { AxiosError, AxiosResponse } from 'axios';
  import { Form, useForm } from 'vee-validate';
  import {
    defineComponent, ref, nextTick, inject, onMounted
  } from 'vue';
  import { decode } from 'html-entities';
  import VueScrollTo from 'vue-scrollto';

  import AjaxForm from '../Form/AjaxForm.vue';

  import { applicantDataRules } from '../../TS/Validations/ApplicantDataValidation';
  import { diplomaRules } from "../../TS/Validations/DiplomaValidation";

  import { uploadFile } from '../../TS/Helpers/UploadFile';

  export default defineComponent({
    props: {
      action: {
        type: String,
        required: true,
      },
      onSuccess: {
        type: Function,
        default: null,
      },
      resetFormOnSuccess: {
        type: Boolean,
        default: false,
      },
      countries: Array,
      formName: {
        type: String,
        required: true,
      },
    },
    components: {
      Form,
      AjaxForm
    },
    extends: { AjaxForm },
    setup(props) {
      const action = ref(props.action);
      const form = ref<HTMLFormElement | null>(null);
      const htmlResponse = ref('');
      const isLoading = ref<boolean>(false);
      let properties: any = {} as { [key: string]: any };
      const countries = ref(props.countries)
      const uploadedName: any = ref([])
      const countUploadedName = ref();

      const formName = ref(props.formName);

      const uploadedFilesNames: any = ref([]);
      const countryName: any = ref('');
      const duration: any = ref();

      const formFields = {
        firstname: '',
        lastname: '',
        instituteName: '',
        addressFirst: '',
        addressSecond: '',
        postCode: '',
        city: '',
        country: '',
        email: '',
        privacyPolicy: '',
      };

      const { validate, values } = useForm({
        keepValuesOnUnmount: true
      });

      onMounted(() => {

        form.value?.addEventListener('submit', async (e) => {
          e.preventDefault();
          const { valid, errors } = await validate();
          if (valid) {
            send();
          } else {
            const firstErrorElement = form.value?.querySelector(".is-invalid");
            if (firstErrorElement) {
              VueScrollTo.scrollTo(firstErrorElement, {
                offset: -200,
              });
            }
          }
        });
      });

      const getErrorMessage = (propertiesKeys: string) => {
        let messages: Array<string> = [];
        for (let property of propertiesKeys.split(',')) {
          property = property.trim();
          if (properties[property]) {
            messages = messages.concat(properties[property].map((error: { message: string }) => error.message));
          }
        }
        return messages.join('<br>');
      };

      const handleErrorResponse = async (error: AxiosError) => {
        if (error.response) {
          properties = error.response.data;
        } else {
          console.error('Oops an error occurred.');
        }
      };

      const handleSuccessResponse = (response: AxiosResponse) => {
        if (response.data && response.data.content) {
          htmlResponse.value = decode(response.data.content);
          nextTick(() => {
            const firstSuccessElement = form.value?.querySelector('.contact-form-success');
            if (firstSuccessElement) {
              VueScrollTo.scrollTo(firstSuccessElement, {
                offset: -200,
              });
            }
          });
        }
        if (props.onSuccess) {
          props.onSuccess();
        }
        reset(props.resetFormOnSuccess);
      };

      const hasPropertyError = (propertiesKeys: string) => {
        for (let property of propertiesKeys.split(',')) {
          property = property.trim();
          if (properties[property] && properties[property].length) {
            return true;
          }
        }
        return false;
      };

      const reset = (resetForm: boolean) => {
        properties = [];
        if (resetForm) {
          form.value?.reset();
        }
      };

      const send = () => {
        if (form.value) {
          const formData = new FormData(form.value);

          if (formFields.country) {
            formData.append(formName.value + '[country]', formFields.country);
          }

          formData.set(formName.value + '[privacyPolicy]', '1');

          isLoading.value = true;
          axios.post(action.value, formData)
            .then((response) => {
              handleSuccessResponse(response);
            })
            .catch((error) => {
              handleErrorResponse(error);

            })
            .then(() => {
              isLoading.value = false;
            });
        }
      };

      const changeCountrySelectValue = (newValue: any) => {
        countries.value?.forEach((country: any) => {
          if (country.uid === Number(newValue)) {
            countryName.value = country?.cn_short_en;
          }
        })
      };


      const uploadFileFunction = (e) => {
        uploadFile(e, uploadedName, countUploadedName, undefined)
      }

      return {
        action,
        form,
        htmlResponse,
        isLoading,
        send,
        hasPropertyError,
        getErrorMessage,
        countries,
        uploadFile,
        uploadFileFunction,
        uploadedFilesNames,
        duration,
        formFields,
        changeCountrySelectValue,
        countryName,
        applicantDataRules,
        diplomaRules,
        uploadedName,
      };
    },
  });




  